<template>
    <div>
        <div class="mb-3 p-3 rounded">
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
                <div class="justify-content-start d-flex">
                    <h4><strong>Ranking de Usuarios</strong></h4>
                </div>
                <div class="justify-content-end d-lg-flex d-md-flex d-sm-grid">
                    <a :href="urlstudentsdetail" class="text-decoration-underline">Ver detalles</a>
                </div>
            </div>
        </div>
        <div>
            <apexchart height="300" type="bar" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
export default {
    props: [
        "dataranking",
        "urlstudentsdetail"
    ],
    data() {
        return {
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 300,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 0,
                        horizontal: true,
                        barHeight: '80%',
                        isFunnel: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opt) {
                        return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
                    },
                    dropShadow: {
                        enabled: true,
                    },
                },
                title: {
                    text: 'Ranking de Usuarios',
                    align: 'middle',
                },
                xaxis: {
                    categories: [
                        'Primer puesto:',
                        'Segundo puesto',
                        'Tercer puesto',
                        'Cuarto puesto',
                        'Quinto puesto'
                    ],
                },
                legend: {
                    show: false,
                },
            },
            series: [{
                name: 'Ranking',
                data: [100, 80, 60, 40, 20]
            }]
        }
    },
    mounted() {

    },
    watch: {
        dataranking(newVal, oldVal) {
            if (typeof newVal != "undefined") {
                let datos = [];
                let conta = 100;
                let valores = [];
                newVal.forEach(element => {
                    datos.push(element.nombrecompleto);
                    valores.push(conta);
                    conta = conta - 20;
                });
                this.chartOptions = {
                    xaxis:{
                        categories : datos
                    }
                };
                this.series = [{
                    data : valores
                }];
            }
        }
    },
    methods: {

    }
}
</script>

<style></style>